import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from 'src/helpers/apiCall'
import { PUT } from 'src/consts/methods'
import {
  MARK_INVOICE_PAID,
  MARK_INVOICE_PAID_FAIL,
  MARK_INVOICE_PAID_SUCCESS,
  MarkInvoicePaidPayload
} from 'src/redux/invoicesReducer'
import { ListInvoice } from 'src/types'
import { PayloadAction } from '@reduxjs/toolkit'

type MarkInvoicePaidAction = PayloadAction<MarkInvoicePaidPayload>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* MarkInvoicePaidFlow({ payload }: MarkInvoicePaidAction): Generator<any, void, any> {
  try {
    const response: ListInvoice = yield call(apiCall, {
      endpoint: `/admin/invoices/${payload.id}/mark_paid`,
      method: PUT,
      params: { invoice: { paid: payload.paid } }
    })
    yield put(MARK_INVOICE_PAID_SUCCESS(response))
  } catch (error) {
    yield put(MARK_INVOICE_PAID_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* MarkInvoicePaidSaga(): Generator<any, void, any> {
  yield takeLatest(MARK_INVOICE_PAID, MarkInvoicePaidFlow)
}
